import channelService from "../../services/channel.service";
import service from '../../services/common.service';
import {environment} from "../../environments/evironment";

/**
 * show channel in iframe or new tab
 * @param {*} channel 
 */
function showChannel(channel){
    channel = JSON.parse(atob(channel));
    var dgElement = document.getElementById("digital-gate");
    var dataChannel = `${channel["Channel"].ChannelName} - ${channel.Id}`;
    var url = channelService.getChanelUrl(channel);
    var container = channel.LoadAction;
    
    saveChannelLog(channel["Channel"].ChannelName);

    console.log("--- pre iframe if");
    console.log(dataChannel);
    if (container == "iframe") {
            console.log("--- inside iframe if");

        var arrayIframes = dgElement.querySelectorAll(`[data-channel]:not([data-channel='${dataChannel}'])`)
        arrayIframes.forEach(function (elem){
                console.log("--- iframeDown");

            elem.classList.add('iframeDown');
        });

        var windowToShow = dgElement.querySelector(`[data-channel='${dataChannel}']`);
        var classListIframeContainer = Array.from(windowToShow.classList);

        if (classListIframeContainer.indexOf("customeImg") >= 0) {
            var totalMargin = window.DGcustomeImg+31;
            windowToShow.style.cssText = `right:${totalMargin}px`;
        }
        
        if (classListIframeContainer.indexOf("iframeDown") >= 0) {
            windowToShow.classList.toggle("iframeDown");
        }
    }else{
        var win = window.open(url, '_blank');
        win.focus();
    }

    hideMenu();
}

/**
 * Remove the class that keeps the frame hidden so that it is visible
 * @param channel
 * @param className
 */
function channelTrigger(channel, className = null) {
    const attribute = '[data-channel="' + channel + '"]';
    const element = document.querySelector(attribute);
    element.classList.remove(className === null ? environment.FRAMEDOWN_CLASS : className);
    hideMenu();
}

function setLanguage(language, appointment = null) {
    localStorage.setItem('lang-chat',language);
    var dataChannel = `Web Messaging - 155`;
    var dgElement = document.getElementById("digital-gate");
    const element = dgElement.querySelector(`[data-channel='${dataChannel}']`);
    var urlSrc = element.querySelector("#iframeContent").getAttribute("src");
    let params = new URLSearchParams(urlSrc);
    params.set("lpep",language);
    appointment? params.set("role",appointment.role): '';
    appointment? params.set("customerId",appointment.customerId): '';
    
    if(!(localStorage.getItem("activeConversation") && localStorage.getItem("activeConversation") == "true"))
    {
        element.querySelector("#iframeContent").setAttribute("src",decodeURIComponent(params.toString()));
    }
}

function showBubble(isVisible = true){
    if (isVisible){
        document.getElementById("digital-gate").style.display="block";
    }
    else{
        document.getElementById("digital-gate").style.display="none";
    }
    var accountKey = window.dgAccountKey;
    const objLog = {
        channel: 'digitalGate',
        evento: 'Show Bubble ' + isVisible,
        status: 'success'
    };
    service.saveEventLog(objLog, accountKey);
}

function hideMenu(){
    var dgElement = document.getElementById("digital-gate");
    var adminCheck = dgElement.getElementsByClassName("adminToggle")[0];
    adminCheck.checked = false
}

function saveChannelLog(channelName){
    var accountKey = window.dgAccountKey;
    var eventLog = { "channel": channelName, "evento": "click", "status": "success" };
    service.saveEventLog(eventLog,accountKey);
}

if(!window.channels){
    window.channels={};
}

window.channels["showChannel"] = showChannel;
window.channels.channelTrigger = channelTrigger;
window.channels.setLanguage = setLanguage;
window.channels.showBubble = showBubble;